export const SET_LANG = 'SET_LANG';
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_MAINTENANCE = 'SET_MAINTENANCE';
